import React, { HTMLAttributes, useMemo } from 'react'
import { CostItem } from '../../entities/Budget'
import { Select, SelectOption } from '../../shared/ui/Select'
import { Info, Prefix, ErrorMessage } from './CostItemSelector.styles'
import { useCostItems } from '../../shared/hooks/api'

interface CostItemSelectorProps extends Omit<
  HTMLAttributes<HTMLDivElement>,
  'onChange'
> {
  selectedCodes?: string[]
  onChange: (values: CostItem[]) => void
  disabled?: boolean
}

export const CostItemSelector: React.FC<CostItemSelectorProps> = ({
  selectedCodes = [],
  onChange,
  disabled,
  ...props
}) => {
  const { data: costItems, isLoading, error } = useCostItems()
  const selectOptions: SelectOption[] = useMemo(
    () =>
      costItems?.map(item => ({
        value: item.code,
        label: `${item.code} ${item.name}`
      })) ?? [],
    [costItems]
  )

  const handleChange = (values: string[]) => {
    const selectedItems =
      costItems?.filter(item => values.includes(item.code)) ?? []
    onChange(selectedItems)
  }

  return (
    <div>
      <Info {...props}>
        <Prefix>Статья бюджета:</Prefix>
        <Select
          options={selectOptions}
          value={selectedCodes}
          onChange={handleChange}
          placeholder="Выберите статью бюджета"
          disabled={disabled || isLoading}
          isMulti
          isLoading={isLoading}
        />
      </Info>
      {error && <ErrorMessage>{error.message}</ErrorMessage>}
    </div>
  )
}
